module.exports = __webpack_public_path__ + "img/tag-belarus.032db787.svg";